
export const Env = {
    Env :                               'hml',
    UrlApi:                             'https://hml.api.indicar.info/api/',
    OrcamentosPDF:                      "https://hml.api.indicar.info/api/v1/baixaOrcamentos/",
    urlSocket:                          "wss://node-indicar.azurewebsites.net",
    UrlPainel:                          'https://hml.portal.indicar.info/',
    AZURE_STORAGE_CONNECTION_STRING:    'BlobEndpoint=https://campindicarhml.blob.core.windows.net/;QueueEndpoint=https://campindicarhml.queue.core.windows.net/;FileEndpoint=https://campindicarhml.file.core.windows.net/;TableEndpoint=https://campindicarhml.table.core.windows.net/;SharedAccessSignature=sv=2022-11-02&ss=bfqt&srt=sco&sp=rwdlacupiytfx&se=2028-01-03T05:03:22Z&st=2025-01-02T21:03:22Z&spr=https,http&sig=wZUMmeU7yje30yGl22N%2FRAcMqYak751RqldwGDRDuUM%3D',
    AZURE_STORAGE_NAME:                 'campindicarhml',
    AZURE_STORAGE_KEY:                  'oiTmV4M0Q2GtMGnmrKxscrOCbX2w6dOCcwPj5ARayZ3WXFSM4LMd9VHmWR/e3V3ezhuJkCZkRy3d+AStpD0mug==',
    AZURE_STORAGE_CONTAINER:            'indicar',
    AZURE_STORAGE_TOKEN:                'sv=2022-11-02&ss=bfqt&srt=sco&sp=rwdlacupiytfx&se=2028-01-03T05:03:22Z&st=2025-01-02T21:03:22Z&spr=https,http&sig=wZUMmeU7yje30yGl22N%2FRAcMqYak751RqldwGDRDuUM%3D',
    AZURE_STORAGE_URL:                  'https://campindicarhml.blob.core.windows.net/'
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts